import React from 'react'
import "./Photos.css";

const photos = () => {
  return (
    <div>
      <div className="wrapper8">
      {/* <h3>Factory Photos</h3> */}
        <div className="container8">
            <div className="hero-section8">
                <div className="gallery">
                    <div className="img-section8">
                        <img src="/images/61.jpg" alt="" />
                    </div>
                    <div className="caption8">
                        <h2>PP WOVEN FABRIC</h2>
                        {/* <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Iure, accusamus.</p> */}

                    </div>
                </div>

                <div className="gallery">
                    <div className="img-section8">
                        <img src="/images/62.jpg" alt="" />
                    </div>
                    <div className="caption8">
                        <h2>PP WOVEN FABRIC</h2>
                        {/* <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Iure, accusamus.</p> */}
                        
                    </div>
                </div>


                <div className="gallery">
                    <div className="img-section8">
                        <img src="/images/63.jpg" alt="" />
                    </div>
                    <div className="caption8">
                        <h2>PP WOVEN FABRIC</h2>
                        {/* <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Iure, accusamus.</p> */}
                        
                    </div>
                </div>


                <div className="gallery">
                    <div className="img-section8">
                        <img src="/images/64.jpg" alt="" />
                    </div>
                    <div className="caption8">
                        <h2>PP WOVEN FABRIC</h2>
                        {/* <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Iure, accusamus.</p> */}
                        
                    </div>
                </div>



                <div className="gallery">
                    <div className="img-section8">
                        <img src="/images/65.jpg" alt="" />
                    </div>
                    <div className="caption8">
                        <h2>PP WOVEN FABRIC</h2>
                        {/* <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Iure, accusamus.</p> */}
                        
                    </div>
                </div>


                <div className="gallery">
                    <div className="img-section8">
                        <img src="/images/66.jpg" alt="" />
                    </div>
                    <div className="caption8">
                        <h2>PP WOVEN FABRIC</h2>
                        {/* <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Iure, accusamus.</p> */}
                        
                    </div>
                </div>



                <div className="gallery">
                    <div className="img-section8">
                        <img src="/images/67.jpg" alt="" />
                    </div>
                    <div className="caption8">
                        <h2>PP WOVEN FABRIC</h2>
                        {/* <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Iure, accusamus.</p> */}

                    </div>
                </div>

                <div className="gallery">
                    <div className="img-section8">
                        <img src="/images/68.jpg" alt="" />
                    </div>
                    <div className="caption8">
                        <h2>PP WOVEN FABRIC</h2>
                        {/* <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Iure, accusamus.</p> */}
                        
                    </div>
                </div>


                <div className="gallery">
                    <div className="img-section8">
                        <img src="/images/69.jpg" alt="" />
                    </div>
                    <div className="caption8">
                        <h2>PP WOVEN FABRIC</h2>
                        {/* <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Iure, accusamus.</p> */}
                        
                    </div>
                </div>


                <div className="gallery">
                    <div className="img-section8">
                        <img src="/images/70.jpg" alt="" />
                    </div>
                    <div className="caption8">
                        <h2>PP WOVEN FABRIC</h2>
                        {/* <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Iure, accusamus.</p> */}
                        
                    </div>
                </div>



                <div className="gallery">
                    <div className="img-section8">
                        <img src="/images/71.jpg" alt="" />
                    </div>
                    <div className="caption8">
                        <h2>PP WOVEN FABRIC</h2>
                        {/* <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Iure, accusamus.</p> */}
                        
                    </div>
                </div>


                <div className="gallery">
                    <div className="img-section8">
                        <img src="/images/72.jpg" alt="" />
                       
                    </div>
                    <div className="caption8">
                        <h2>PP WOVEN FABRIC</h2>
                        {/* <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Iure, accusamus.</p> */}
                        
                    </div>
                </div>



            </div>
        </div>
      </div>
  
  
    </div>
  )
}

export default photos
